import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import ScrollProgress from './ScrollProgress';
import RouteFallback from './RouteFallback';

/**
 * Persistent chrome for the dashboard family (/dashboard and /dashboard/*).
 * Keeping Navbar/Footer/background mounted across these routes means only the
 * inner page swaps on navigation — no full-page teardown/flicker.
 */
export default function DashboardLayout() {
  return (
    <main className="relative min-h-screen bg-[var(--bg)] text-[var(--text)] grain">
      <Navbar solid />
      <ScrollProgress />
      <Suspense fallback={<RouteFallback />}>
        <Outlet />
      </Suspense>
      <Footer />
    </main>
  );
}
